import React from 'react';
import { RouteComponentProps, withRouter } from 'react-router-dom';

import { ApiSettings, SettingsFrame } from '../../../components';
import { Preloader, ToDashboardError } from '../../../components/ui';
import { useCurrentProject } from '../../../contexts/settings';

type RouteParams = { projectId: string; confPage: string };

const ApiSettingsPage = ({ match }: RouteComponentProps): JSX.Element | null => {
  const { projectId } = match.params as RouteParams;
  const { currentProjectFetching, currentProjectType, error } = useCurrentProject(projectId);

  if (currentProjectFetching) {
    return (
      <SettingsFrame projectId={projectId} projectType={currentProjectType}>
        <Preloader />
      </SettingsFrame>
    );
  }

  if (error) {
    return <ToDashboardError error={error} pageName="api-settings_open" />;
  }

  return (
    <SettingsFrame projectId={projectId} projectType={currentProjectType}>
      <ApiSettings projectId={projectId} />
    </SettingsFrame>
  );
};

export default withRouter(ApiSettingsPage);
